module.exports = __webpack_public_path__ + "img/hitachi-digital-host-1.97226ba1.png";